import React from 'react'
import {Page} from 'react-onsenui';
import {withRouter} from "react-router-dom"
import connect from "react-redux/es/connect/connect";
import {NAVER_LOGIN, NAVER_LOGIN_PRODUCTION} from "../../modules/variable/common_variable";
import {Modal} from 'react-onsenui'
import firebase from 'firebase/app';
import 'firebase/auth';
import Loader from "react-loader-spinner";
import {OPEN_EXTERNAL_LINK} from "../../modules/variable/common_variable";

/*const uiConfig = {
    signInSuccessUrl: '/home',
    signInOptions: [
        {provider: firebase.auth.PhoneAuthProvider.PROVIDER_ID, defaultCountry: 'KR'},
        {
            provider: firebase.auth.EmailAuthProvider.PROVIDER_ID,
            requireDisplayName: false,
        }
    ]
};*/

class Intro extends React.Component {
    state = {
        showLoginButton : false,
        isOnGoingAnonymousSignInProcess: false
    };

    componentDidMount() {
        setTimeout(() => {
            const naverLogin = new window.naver.LoginWithNaverId(
                {
                    clientId: process.env.NODE_ENV.toUpperCase() === 'PRODUCTION' ? NAVER_LOGIN_PRODUCTION.clientId: NAVER_LOGIN.clientId,
                    callbackUrl: process.env.NODE_ENV.toUpperCase() === 'PRODUCTION' ? NAVER_LOGIN_PRODUCTION.callbackUrl : NAVER_LOGIN.callbackUrl,
                    isPopup: false, /* 팝업을 통한 연동처리 여부 */
                    loginButton: {color: "green", type: 3, height: 50} /* 로그인 버튼의 타입을 지정 */
                }
            );
            naverLogin.init();

            const everLoggedIn = localStorage.getItem("EVER_LOGGED_IN");
            if(everLoggedIn === 'TRUE'){
                document.getElementById('naverIdLogin_loginButton').click();
            }

            this.setState({showLoginButton: true});
        }, 1000);

        /*if(this.props.userInfo.isSignedIn){
            //this.props.history.push('/home');
        }*/
    }

    componentWillReceiveProps(nextProps) {
        /*if(nextProps.userInfo.isSignedIn){
            nextProps.history.push('/home');
        }*/
    }

    naverLogin = () => {

    };

    goToSignIn = () => {
        this.props.history.push("/signIn");
    };

    anonymousSignIn = () => {
        this.setState({isOnGoingAnonymousSignInProcess: true});
        firebase.auth().signInAnonymously().catch(function(error) {
            console.error(error);
        });
    };

    render() {
        return (
            <Page>
                <div className="intro-wrapper">
                    <Modal className="intro-modal" isOpen={true} animation={"lift"}>
                        <div className="intro-image-area">
                            <img src={'/assets/image/intro/logo_with_catchphrase.png'} alt={'logo_with_catchphrase'}/>
                        </div>

                        <div className="intro-button-area" style={this.state.showLoginButton ? {} : {display: 'none'}}>
                            <div id="naverIdLogin"></div>

                            {/*<button className="button" onClick={() => window.open("intent://navigation?dlat=37.7908455&dlng=126.6952167&dname=%ED%95%9C%EA%B5%AD%EA%B7%BC%ED%98%84%EB%8C%80%EC%82%AC%EB%B0%95%EB%AC%BC%EA%B4%80&appname=com.hopse.picnici#Intent;scheme=nmap;action=android.intent.action.VIEW;category=android.intent.category.BROWSABLE;package=com.nhn.android.nmap;end")}>
                                인텐트 네이버 지도
                            </button>
                            <button className="button" onClick={() => window.open("nmap://navigation?dlat=37.7908455&dlng=126.6952167&dname=%ED%95%9C%EA%B5%AD%EA%B7%BC%ED%98%84%EB%8C%80%EC%82%AC%EB%B0%95%EB%AC%BC%EA%B4%80&appname=com.hopse.picnici")}>
                                지도
                            </button>*/}

                            {/*<button className="button" onClick={() => window.open("http://m.tmap.co.kr/tmap2/mobile/route.jsp?name=%EC%84%9C%EB%B4%89%EC%82%AC%EA%B3%84%EA%B3%A1%20%EB%A7%88%EC%9D%84%EA%B4%80%EB%A6%AC%ED%9C%B4%EC%96%91%EC%A7%80&lon=128.2174044770&lat=37.7049221513"
                            )}>
                                지도
                            </button>*/}

                            <button className="button button--material" onClick={this.anonymousSignIn}>
                                {
                                    this.state.isOnGoingAnonymousSignInProcess ?
                                        <Loader type="ThreeDots" color="#00BFFF" height={40} width={40} />
                                        :
                                        "체험하기"
                                }
                            </button>
                        </div>

                        <div className="intro-information-area">
                            <a onClick={() => OPEN_EXTERNAL_LINK('https://youtu.be/aa5D17T1Z2o')}>소개 영상</a>
                            <a onClick={() => this.props.history.push("/privacy")}>개인정보 처리방침</a>
                            <a>©2019 HOPSE</a>
                        </div>
                    </Modal>

                </div>
            </Page>
        )
    }
}

const mapStateToProps = ({ user }) => ({
    userInfo: user.userInfo
});

export default withRouter(connect(
    mapStateToProps
)(Intro))